import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { IframeAdapterService } from './core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements AfterViewInit, OnDestroy {
  title: string;
  hideBackground = false;
  activeBg = true;
  observer: ResizeObserver | undefined;
  enableScrollUp = true;

  constructor(
    private iframeService: IframeAdapterService,
    private router: Router
  ) {
    this.title = 'Agenda tu visita';
  }

  ngAfterViewInit(): void {
    this.observeScrollHeight();
  }

  observeScrollHeight() {
  const container = document.getElementById('dynamic-content');
  if (!container) {
    console.warn('Dynamic content container not found');
    return;
  }

  this.observer = new ResizeObserver(() => {
    this.iframeService.iframeAdjustement();
  });
  this.observer.observe(container);
}


  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = undefined;
    }
  }
}
